export default __webpack_public_path__ + "static/media/ghost_green.e0e0f723.png";